import { useTranslation } from 'react-i18next';
import {
  Action,
  ActionsTableMenu,
} from 'src/components/atoms/actions-table-menu';
import { usePermissions } from 'src/permissions/can';

interface Props {
  onEditName: () => void;
  onDelete: () => void;
}

export const BookingRulesActionsTableMenu = ({
  onEditName,
  onDelete,
}: Props) => {
  const { t } = useTranslation();

  const permissions = usePermissions();

  const actions: Action[] = [
    {
      id: 'editName',
      label: t('bookingRules:common.actions.editName'),
      onClick: onEditName,
      disabled: permissions.cannot('update', 'BookingRules'),
      tooltip: t('common:notSufficientPermissions'),
    },
    {
      id: 'delete',
      label: t('bookingRules:common.actions.delete'),
      onClick: onDelete,
      disabled: permissions.cannot('delete', 'BookingRules'),
      tooltip: t('common:notSufficientPermissions'),
    },
  ];

  return <ActionsTableMenu actions={actions} />;
};
